module.exports = __webpack_public_path__ + "static/media/books.287fe2b8.png";